import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('website_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setSubmitted(true);
      setEmail('');
      setTimeout(() => setSubmitted(false), 3000);
      return;
    }
    formData.delete('website_alt');
    try {
      await fetch('https://readdy.ai/api/form/d8tri20b9jno5e72boqg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as any).toString(),
      });
      setSubmitted(true);
      setEmail('');
      setTimeout(() => setSubmitted(false), 3000);
    } catch {
      // silently handle
    }
  };

  const firstHalf = categories.slice(0, 7);
  const secondHalf = categories.slice(7);

  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-2/5">
            <h3 className="font-heading text-2xl md:text-3xl font-bold leading-tight mb-3">
              ACBuy<br />Spreadsheet
            </h3>
            <p className="text-secondary-300 text-sm leading-relaxed mb-8 max-w-sm">
              The most updated ACBuy Spreadsheet database for global buyers to compare products, prices, and shipping efficiency — updated daily.
            </p>

            <form onSubmit={handleSubmit} data-readdy-form="">
              <label className="text-xs font-semibold text-secondary-300 uppercase tracking-wider mb-2 block">
                Stay Updated
              </label>
              <div className="flex flex-col sm:flex-row gap-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  required
                  className="flex-1 bg-transparent border-b border-secondary-600 focus:border-primary-400 outline-none py-2.5 text-sm text-background-50 placeholder:text-secondary-500 transition-colors duration-200"
                />
                <button
                  type="submit"
                  className="px-6 py-2.5 text-sm font-semibold text-secondary-900 bg-primary-400 hover:bg-primary-300 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  {submitted ? 'Subscribed!' : 'Subscribe'}
                </button>
              </div>
              <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" className="honeypot-field" />
              {submitted && (
                <p className="text-xs text-primary-300 mt-2">Thanks for subscribing! We'll keep you updated.</p>
              )}
            </form>
          </div>

          <div className="lg:w-3/5 grid grid-cols-2 md:grid-cols-3 gap-8">
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">Categories</h4>
              <ul className="space-y-2.5">
                {firstHalf.map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-secondary-300 hover:text-primary-300 transition-colors duration-200"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">More Categories</h4>
              <ul className="space-y-2.5">
                {secondHalf.map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-secondary-300 hover:text-primary-300 transition-colors duration-200"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">Quick Links</h4>
              <ul className="space-y-2.5">
                <li>
                  <a href="/" className="text-sm text-secondary-300 hover:text-primary-300 transition-colors duration-200">
                    Home
                  </a>
                </li>
                <li>
                  <a href="/shopping-guide" className="text-sm text-secondary-300 hover:text-primary-300 transition-colors duration-200">
                    Shopping Guide
                  </a>
                </li>
                <li>
                  <a href="/article/acbuy-spreadsheet-guide" className="text-sm text-secondary-300 hover:text-primary-300 transition-colors duration-200">
                    Spreadsheet Guide
                  </a>
                </li>
                <li>
                  <a
                    href="https://kaspreadsheet.com/"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-secondary-300 hover:text-primary-300 transition-colors duration-200"
                  >
                    Full Platform
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between mt-12 pt-8 border-t border-secondary-700">
          <p className="text-xs text-secondary-400">
            &copy; {new Date().getFullYear()} ACBuy Spreadsheet. All rights reserved.
          </p>
          <p className="text-xs text-secondary-500 mt-2 sm:mt-0">
            Last updated: June 2026
          </p>
        </div>
      </div>
    </footer>
  );
}